import { Text, Tooltip } from '@iwoca/orion';
import { Cvv } from 'frames-react';
import { FormattedMessage, useIntl } from 'react-intl';

import { DebitCardFieldWrapper } from '../../DebitCardFieldWrapper';

export const CVVField = () => {
    const intl = useIntl();

    const label = (
        <Text>
            <FormattedMessage id="_.link_debit_card.cvv" defaultMessage="CVC" />
            <Tooltip
                dataTestId="cvvHelpTooltip"
                placement="top"
                content={intl.formatMessage({
                    id: '_.link_debit_card.cvv_number_tooltip',
                    defaultMessage:
                        'The 3 digit number on the back of your card'
                })}
            />
        </Text>
    );

    return (
        <DebitCardFieldWrapper label={label} htmlFor="cvv">
            {/* Stripe adds .StripeElement automatically — CheckoutElement mirrors that so both processors can be styled uniformly */}
            <Cvv className="CheckoutElement" data-testid="checkout-cvv" />
        </DebitCardFieldWrapper>
    );
};
